import {Navigate, Route, Routes} from "react-router-dom";
import {AppLayout} from "common/Layout";
import {appRouterPaths} from "services/navigation";
import {HomePage} from "pages/Home";
import {VideoPage} from "pages/Video";
import {TheoryPage} from "pages/Theory";
import {TargetPage} from "pages/Target";
import {InteractivePage} from "pages/Interactive";
import {TestPage} from "pages/Test";
import {LiteraturePage} from "pages/Literature";
import {AnnotationPage} from "pages/Annotation";
import {MethodologicalModulePage} from "pages/MethodologicalModule";
import {PracticalModulePage} from "pages/PracticalModule";
import {AdditionalMaterialsPage} from "pages/AdditionalMaterials";
import {GLOBAL_CONFIG} from "../../config/config";
import {PageType} from "../../config/types";

export const AppRouting = () => {
  const pageIsCreated = (type: PageType): boolean => {
    return GLOBAL_CONFIG.pages.some(page => page.type === type);
  };

  return (
    <Routes>
      <Route element={<AppLayout/>}>
        <Route path={appRouterPaths.home} element={<HomePage/>}/>
        {pageIsCreated(PageType.VIDEO) && <Route path={appRouterPaths.video} element={<VideoPage/>}/>}
        {pageIsCreated(PageType.THEORY) && <Route path={appRouterPaths.theory} element={<TheoryPage/>}/>}
        {pageIsCreated(PageType.TARGET) && <Route path={appRouterPaths.target} element={<TargetPage/>}/>}
        {pageIsCreated(PageType.INTERACTIVE) && <Route path={appRouterPaths.interactive} element={<InteractivePage/>}/>}
        {pageIsCreated(PageType.TEST) && <Route path={appRouterPaths.test} element={<TestPage/>}/>}
        {pageIsCreated(PageType.LITERATURE) && <Route path={appRouterPaths.literature} element={<LiteraturePage/>}/>}
        {pageIsCreated(PageType.ANNOTATION) && <Route path={appRouterPaths.annotation} element={<AnnotationPage/>}/>}
        {pageIsCreated(PageType.METHODOLOGICAL_MODULE)
          && <Route path={appRouterPaths.methodologicalModule} element={<MethodologicalModulePage/>}/>
        }
        {pageIsCreated(PageType.PRACTICAL_MODULE)
          && <Route path={appRouterPaths.practicalModule} element={<PracticalModulePage/>}/>
        }
        {pageIsCreated(PageType.ADDITIONAL_MATERIALS)
          && <Route path={appRouterPaths.additionalMaterials} element={<AdditionalMaterialsPage/>}/>
        }
        <Route path="*" element={<Navigate to={appRouterPaths.home}/>}/>
      </Route>
    </Routes>
  );
};
